// types from lkfl-api-spec /taxpayer/hasUnits
export const unitTypes = {
  UNEXPLAINED_PAYMENTS: 'UNEXPLAINED_PAYMENTS',
  ADMINISTRATIVE_FINES: 'ADMINISTRATIVE_FINES',
  INCOME_DATA: 'INCOME_DATA',
  INSURANCE_TAXES: 'INSURANCE_TAXES',
  SELF_PAID_INSURANCE_TAXES: 'SELF_PAID_INSURANCE_TAXES',
  LK_20_NOTIFICATIONS: 'LK_20_NOTIFICATIONS',
  QES_REQUEST_AVAILABILITY: 'QES_REQUEST_AVAILABILITY',
  REGISTER_IP_AVAILABILITY: 'REGISTER_IP_AVAILABILITY',
  REGISTER_ORGANIZATION_AVAILABILITY: 'REGISTER_ORGANIZATION_AVAILABILITY',
  PERCENT_DEPOSITS: 'PERCENT_DEPOSITS',
  INVEST_ACCOUNT_DATA: 'INVEST_ACCOUNT_DATA',
};
